export default __webpack_public_path__ + "354b71886a14d6c5984844f4a597b38a.svg";